import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-questions-to-ask-ahead-of-ai-implementation',
  templateUrl: './questions-to-ask-ahead-of-ai-implementation.component.html',
  styleUrls: ['./questions-to-ask-ahead-of-ai-implementation.component.scss']
})
export class QuestionsToAskAheadOfAIImplementationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
